import { cn } from '@/lib/utils';
import { PageIntroProps } from './types';

const PageIntro = (props: PageIntroProps) => {
  const {
    aside,
    className,
    eyebrow,
    title
  } = props;

  return (
    <section className={cn('flex min-w-0 w-full items-start justify-between', className)}>
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        {eyebrow && (
          <p className="w-full truncate font-sans text-sm font-semibold leading-5 text-muted-foreground">
            {eyebrow}
          </p>
        )}
        <p className="w-full truncate font-sans text-xl font-semibold leading-7 text-foreground">
          {title}
        </p>
      </div>
      {aside && <div className="min-[769px]:hidden">{aside}</div>}
    </section>
  );
};

export default PageIntro;